import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateCostPlanningDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateCostPlanningMutation,
  ProjectManagementProjectDetailsPageSettingsPageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface createFixedCostPlanningDto {
  projectId: number
  budgetAllocationCents: number
  feeAmountCents?: number
}

export const useCreateFixedCostPlanning = (companyId: number) => {
  const [createFixedCostPlanning] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateCostPlanningDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateCostPlanningMutation
      ) => data.projectManagementMutations.createProjectmanagementFixedCostPlanning,
    }
  )

  return {
    create(dto: createFixedCostPlanningDto) {
      const { projectId, budgetAllocationCents, feeAmountCents } = dto
      return createFixedCostPlanning({
        variables: {
          projectId: projectId,
          budgetAllocationCents: budgetAllocationCents,
          feeAmountCents: feeAmountCents,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ProjectManagementProjectDetailsPageSettingsPageDocument,
            variables: {
              companyId,
              projectId,
              projectBudgetIsEnabled: true,
              projectCostsIsEnabled: true,
            },
          },
        ],
      })
    },
  }
}
